// 错误展示文案由调用方提供；空 message 使用兜底，避免出现空白提示。
export function getErrorMessage(cause: unknown, fallback = "请求失败"): string {
  return cause instanceof Error && cause.message ? cause.message : fallback;
}

// 保留 Error 的类型、堆栈与附加字段；仅转换非 Error 的异常。
export function toError(cause: unknown, fallback?: string): Error {
  return cause instanceof Error ? cause : new Error(fallback ?? String(cause));
}
